import apiClient from "./client";
import { getFrontendBaseUrl } from "../utils/appBaseUrl";

export async function fetchUsers() {
  const { data } = await apiClient.get("/users");
  return data;
}

export async function fetchBranches(includeInactive = false) {
  const { data } = await apiClient.get("/users/branches", {
    params: includeInactive ? { include_inactive: true } : undefined,
  });
  return data;
}

export async function createBranch(payload) {
  const { data } = await apiClient.post("/users/branches", payload);
  return data;
}

export async function updateBranch(branchId, payload) {
  const { data } = await apiClient.patch(`/users/branches/${branchId}`, payload);
  return data;
}

export async function fetchDepartments(includeInactive = false) {
  const { data } = await apiClient.get("/users/departments", {
    params: includeInactive ? { include_inactive: true } : undefined,
  });
  return data;
}

export async function updateDepartment(departmentId, payload) {
  const { data } = await apiClient.patch(`/users/departments/${departmentId}`, payload);
  return data;
}

export async function createDepartment(payload) {
  const { data } = await apiClient.post("/users/departments", payload);
  return data;
}

export async function createUser(payload) {
  const { data } = await apiClient.post("/users", payload);
  return data;
}

export async function updateUser(userId, payload) {
  const { data } = await apiClient.patch(`/users/${userId}`, payload);
  return data;
}

export async function adminSetUserPassword(userId, payload) {
  const { data } = await apiClient.post(`/users/${userId}/password`, payload);
  return data;
}

export async function sendUserPasswordResetEmail(userId) {
  const { data } = await apiClient.post(`/users/${userId}/password-reset-email`, {
    frontend_base_url: getFrontendBaseUrl(),
  });
  return data;
}

/** Update the signed-in user's profile, password, and/or preferences. */
export async function updateMyProfile(payload) {
  const { data } = await apiClient.patch("/users/me", payload);
  return data;
}

/** Persist the signed-in user's own preferences (e.g. theme/layout). */
export async function updateMyPreferences(preferences) {
  return updateMyProfile({ preferences });
}
